module.exports = __webpack_public_path__ + "static/img/ts_fwys_pic.59e0f43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ts_fwys_pic.jpg
// module id = x4UF
// module chunks = 1